// Normalizes the v2 `payment_info` object (from /v2/subscriptions/users/products)
// into the flat card shape the Payment Method UI renders.
//
// v2 payment_info: { has_payment_method, type:"card", last_four, card_brand, expiration:{month,year} }
// It is omitted entirely when no card is on file, and carries no cardholder name / billing address.

/**
 * @param {Object|null|undefined} payment_info - v2 payment_info object
 * @returns {{card_type: string, last_four: string, expiration_month: number, expiration_year: number}|null}
 */
export function mapV2PaymentInfo(payment_info) {
  if (!payment_info || !payment_info.has_payment_method) return null;
  if (!payment_info.last_four) return null;
  return {
    card_type: payment_info.card_brand,
    last_four: payment_info.last_four,
    expiration_month: payment_info.expiration?.month,
    expiration_year: payment_info.expiration?.year,
  };
}
